import { useWindowSize } from 'CustomHooks';
import React, { useEffect, useState } from 'react';

const withWindowResizeAwareness = <T extends object>(
  WrappedComponent: React.ComponentType<T>,
) => {
  return (props: T) => {
    const windowSize = useWindowSize();
    const [key, setKey] = useState(1);

    useEffect(() => {
      setKey((prevKey) => prevKey + 1);
    }, [windowSize]);

    return <WrappedComponent id='hoc-winresizeawareness' {...props} key={key} />;
  };
};

export default withWindowResizeAwareness;
